import request from "@/utils/request";
// import qs from 'qs'

// export function searchInfo(number) {
//   return request({
//     url: '/api/search-invoice-info',
//     method: 'post',
//     params: { number }
//   })
// }

// ltlopenapi.ltl.kr/ltl-api/interfaces/api/searchInvoiceInfo?number=

export function searchInfo(number) {
  return request({
    url: "/ltl-api/interfaces/api/searchInvoiceInfo",
    method: "get",
    params: { number },
  });
}
